var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 463,
    viewBox: "0 0 186 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1647 92.5301C78.1584 115.247 104.415 169.685 121.997 214.074C139.013 257.03 114.868 290.67 100.903 334.712C85.7964 382.352 90.0749 433.689 42.0118 447.389C-4.02658 460.512 -5.66566 376.656 -48.4403 355.161C-85.3589 336.608 -163.352 366.415 -186.806 332.399C-216.382 289.506 -272.235 216.117 -258.601 165.831C-243.965 111.849 -152.744 147.43 -100.119 128.485C-49.8974 110.405 -10.7828 67.133 36.1647 92.5301Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 108.835C69.858 129.315 93.5289 178.39 109.38 218.407C124.72 257.131 102.954 287.457 90.3645 327.16C76.7464 370.107 80.604 416.386 37.2748 428.736C-4.22906 440.566 -5.70753 364.971 -44.2695 345.593C-77.5522 328.867 -147.863 355.738 -169.008 325.072C-195.671 286.404 -246.024 220.245 -233.733 174.912C-220.539 126.248 -138.302 158.325 -90.8604 141.247C-45.5855 124.948 -10.3238 85.9396 32 108.835Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8817 119.496C63.8815 138.429 85.7674 183.793 100.424 220.783C114.607 256.579 94.4868 284.611 82.8503 321.31C70.2632 361.007 73.8321 403.786 33.776 415.199C-4.59261 426.132 -5.96363 356.255 -41.6142 338.34C-72.3842 322.878 -137.383 347.712 -156.933 319.365C-181.585 283.62 -228.138 222.462 -216.778 180.56C-204.583 135.577 -128.555 165.233 -84.6978 149.449C-42.8432 134.386 -10.2468 98.3298 28.8817 119.496Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1492 133.06C53.0688 149.241 71.7875 187.992 84.325 219.59C96.4576 250.168 79.2688 274.103 69.3337 305.444C58.587 339.346 61.6496 375.885 27.4172 385.621C-5.37309 394.948 -6.56496 335.266 -37.0405 319.955C-63.3437 306.739 -118.891 327.931 -135.608 303.715C-156.688 273.178 -196.494 220.93 -186.797 185.144C-176.387 146.728 -111.398 172.079 -73.9179 158.61C-38.1494 145.757 -10.2998 114.971 23.1492 133.06Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.581 144.492C50.8311 159.233 67.8689 194.558 79.2783 223.363C90.3193 251.238 74.6516 273.068 65.5891 301.648C55.7863 332.562 58.5624 365.876 27.3737 374.766C-2.50112 383.282 -3.56435 328.867 -31.3211 314.918C-55.2779 302.879 -105.888 322.222 -121.108 300.148C-140.3 272.314 -176.543 224.691 -167.696 192.059C-158.198 157.029 -99.0036 180.118 -64.8548 167.824C-32.2655 156.091 -6.88349 128.011 23.581 144.492Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8561 158.221C43.612 171.073 58.4619 201.879 68.4055 226.998C78.028 251.307 64.3655 270.347 56.4608 295.273C47.9103 322.235 50.3264 351.287 23.1336 359.044C-2.91373 366.475 -3.83383 319.019 -28.0317 306.858C-48.9168 296.361 -93.0439 313.237 -106.31 293.988C-123.039 269.716 -154.631 228.188 -146.914 199.729C-138.629 169.178 -87.0234 189.306 -57.2493 178.58C-28.835 168.344 -6.70223 143.852 19.8561 158.221Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7467 166.784C41.4062 178.503 54.9433 206.597 64.0074 229.505C72.7789 251.674 60.3194 269.04 53.1094 291.773C45.3103 316.364 47.5105 342.86 22.7151 349.937C-1.03571 356.717 -1.86991 313.437 -23.9325 302.348C-42.9745 292.777 -83.2115 308.172 -95.306 290.618C-110.557 268.484 -139.359 230.613 -132.319 204.657C-124.762 176.793 -77.7096 195.145 -50.5604 185.36C-24.6511 176.021 -4.46789 153.682 19.7467 166.784Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1828 192.756C30.4273 201.004 39.9567 220.772 46.3378 236.891C52.5128 252.489 43.7456 264.707 38.6732 280.702C33.1864 298.003 34.7371 316.646 17.2872 321.624C0.572452 326.392 -0.0182557 295.94 -15.5463 288.136C-28.9485 281.4 -57.2652 292.229 -65.7785 279.877C-76.5136 264.302 -96.7869 237.653 -91.8346 219.391C-86.5183 199.786 -59.431 200.316 -40.3248 193.433C-22.0912 186.865 -1.86 183.535 15.1828 192.756Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2628 204.262C24.5203 210.887 32.1961 226.742 37.3387 239.67C42.3152 252.18 38.9521 263.582 31.2206 274.783C27.9345 277.731 27.6909 278.335 20.9788 280.238C7.55206 284.044 0.144104 286.962 -12.3408 280.691C-23.1165 275.279 -45.8604 283.933 -52.7128 274.024C-61.3536 261.528 -77.6691 240.148 -73.7067 225.513C-69.453 209.802 -47.6864 210.252 -32.34 204.753C-17.6944 199.504 -1.4406 196.854 12.2628 204.262Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18943 214.623C14.2647 219.515 19.9785 231.165 23.8127 240.661C27.523 249.85 25.0677 258.205 19.3839 266.401C16.9633 268.554 16.785 268.997 11.83 270.375C1.91809 273.132 -3.54844 275.252 -12.7908 270.62C-20.7679 266.622 -37.552 272.91 -42.6417 265.624C-49.0598 256.435 -61.1726 240.709 -58.283 229.985C-55.1809 218.473 -39.0951 218.86 -27.769 214.866C-16.9603 211.055 -4.95634 209.154 5.18943 214.623Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.93964 224.143C3.46823 227.054 6.88245 233.969 9.1753 239.604C11.3941 245.058 9.94165 250.01 6.567 254.864C5.12839 256.139 5.02267 256.401 2.07445 257.213C-3.82311 258.837 -8.23194 262.185 -11.5107 261.936C-14.7895 261.686 -15.5514 264.694 -30.3579 254.335C-34.1887 248.879 -41.4167 239.54 -39.7082 233.183C-37.8741 226.359 -28.2977 226.607 -21.5597 224.251C-15.1294 222.002 -7.98544 220.888 -1.93964 224.143Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.66752 229.137C-0.740041 231.25 1.74194 236.266 3.4092 240.353C5.02263 244.308 6.40374 248.796 1.52273 251.415C0.478895 252.338 0.402271 252.528 -1.73776 253.116C-6.01863 254.29 -9.21787 256.716 -11.5984 256.534C-13.9789 256.351 -19.1218 257.758 -25.2851 251.014C-28.0688 247.057 -33.3207 240.282 -32.0833 235.674C-30.755 230.728 -23.8024 230.911 -18.9116 229.206C-14.2443 227.579 -9.05831 226.775 -4.66752 229.137Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftImg);
export default __webpack_public_path__ + "static/media/Left-img.518087f086abce1c5c4c1f2b93f83e10.svg";
export { ForwardRef as ReactComponent };